import React, { useRef, useState } from "react";
import {
  Form,
  InputGroup,
  Button,
} from "react-bootstrap";
import "./Contact.css";
import emailjs from "emailjs-com";
import { SiMinutemailer, SiMaildotru } from "react-icons/si";
import { FaUserAlt, FaPhone } from "react-icons/fa";
import { MdSubject } from "react-icons/md";

const Contact = () => {
  const [count, setCount] = useState(0);
  const [sent, setSent] = useState(false)

  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();
    console.log(form.current.value)
    emailjs
      .sendForm(
        "service_r8uh8sa",
        "template_dycfg6q",
        form.current,
        "user_wvKObHkK1EaHxvncaI2k3"
      )
      .then(
        (result) => {
          console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        }
      );
    form.current.reset();
    setCount(0)
    setSent(true)
    setTimeout(() => {
      setSent(false)
    }, 3000);
  };
  return (
    <div id="contact" className="contact-container ">
      <div className="page-title mx-auto">
        <h1 className="writeMe-title text-center">
          Write <span style={{ color: "#5c4ffd" }}>Me</span>
        </h1>
      </div>

      <div className="container contact-form ps-sm-3 ps-md-5 ps-lg-5 ps-xl-5 ps-xxl-5 pe-sm-3 pe-md-5 pe-xl-5 pe-xxl-5">
        <form ref={form} className="overflow-auto d-block mx-auto">
          <InputGroup className="mt-1 mb-1">
            <InputGroup.Text>
              <FaUserAlt />
            </InputGroup.Text>
            <Form.Control
              type="text"
              name="name"
              required
              placeholder="Write your name"
              className="input-field"
              onChange={(e)=>{
                (e?.target?.value?.length === 3 && count === 0) && setCount(count+1) 
                e?.target?.value?.length === 0 && setCount(count-1)
              }}
            />
          </InputGroup>

          <InputGroup className="mt-1 mb-1">
            <InputGroup.Text>
              <SiMaildotru />
            </InputGroup.Text>
            <Form.Control
              type="text"
              name="email"
              required
              placeholder="Write your email"
              className="input-field"
              onChange={(e)=>{
                (e?.target?.value?.length === 3 && count === 1) && setCount(count+1) 
                e?.target?.value?.length === 0 && setCount(count-1)
              }}
            />
          </InputGroup>

          <InputGroup className="mt-1 mb-1">
            <InputGroup.Text>
              <FaPhone />
            </InputGroup.Text>
            <Form.Control
              type="tel"
              name="phone"
              required
              placeholder="phone number with country code"
              className="input-field"
              onChange={(e)=>{
                (e?.target?.value?.length === 3 && count === 2) && setCount(count+1) 
                e?.target?.value?.length === 0 && setCount(count-1)
              }}
            />
          </InputGroup>

          <InputGroup className="mt-1 mb-1">
            <InputGroup.Text>
              <MdSubject />
            </InputGroup.Text>
            <Form.Control
              type="text"
              name="subject"
              required
              placeholder="write your subject"
              className="input-field"
              onChange={(e)=>{
                (e?.target?.value?.length === 3 && count === 3) && setCount(count+1) 
                e?.target?.value?.length === 0 && setCount(count-1)
              }}
            />
          </InputGroup>

          <InputGroup className="mt-2 mb-1">
            <Form.Control
              as="textarea"
              type="text"
              name="message"
              placeholder="Leave your message here"
              maxlength="300"
              className="ps-4 pe-4 pb-4 pt-1 overflow-scroll input-field"
              required
              onChange={(e)=>{
                (e?.target?.value?.length === 3 && count === 4) && setCount(count+1) 
                e?.target?.value?.length === 0 && setCount(count-1)
              }}
            />
          </InputGroup>
          {
            sent && <p style={{textAlign:"center", color:"#008700", fontSize:"1.2rem" }}>Successfully Sent.</p>
          }
          <Button
            onClick={sendEmail}
            variant="primary"
            type="submit"
            className="d-block mt-3 mb-5 mx-auto w-25 fs-5 input-field"
            disabled = {count === 5 ? false : true}
          >
            Send <SiMinutemailer />
          </Button>
        </form>
      </div>
    </div>
  );
};

export default Contact;
